import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=78450b48"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ResetPassword.vue?vue&type=style&index=0&id=78450b48&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "001d78d2"
  
)

export default component.exports